import { Link } from "react-router-dom";

export const AboutHero = () => {
    return (
        <div className="about_preview" direction="up" duration={1500}>
            <img
                src="https://res.cloudinary.com/dx9rdmmff/image/upload/v1792936979/Magda/hero/WhatsApp_Image_2026-10-25_at_14.53.44_y19ziv.jpg"
                alt="Magdalena Olszyńska"
            />

            <div className="about_text">
                <h2>O mnie</h2>
                <p>
                    Jestem inżynierem z wieloletnim doświadczeniem w branży
                    medycznej. Ukończyłam kierunek{" "}
                    <strong>Inżynieria Mechaniczno-Medyczna</strong> na
                    Politechnice Gdańskiej oraz Gdańskim Uniwersytecie
                    Medycznym.
                </p>
                <p>
                    Od ponad 15 lat współpracuję ze szpitalami i firmami
                    medycznymi – początkowo jako przedstawicielka medyczna, a
                    następnie jako kierownik działu aparatury medycznej w jednym
                    z największych kompleksów szpitalnych na Pomorzu.
                </p>
                <p>
                    Specjalizuję się w realizacji projektów obejmujących budowę,
                    modernizację i wyposażenie placówek medycznych. W mojej
                    pracy stawiam na <strong>rzetelność</strong>,{" "}
                    <strong>terminowość</strong> i{" "}
                    <strong>partnerską współpracę</strong>.
                </p>
                <blockquote>
                    "Szpital to miejsce, gdzie technologia spotyka się z ludzką
                    troską."
                </blockquote>
                <div className="more_button_container">
                    <Link to="/about">
                        <button className="more_button">Więcej</button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AboutHero;
